import { VehicleEvent } from '@core/classes/VehicleEvent';
import request from '@core/services/request';

export const spireonAPI = {
	getAsset: (vin: any, storeState: any, account: any) => {
		return request.getSpecial(`/Spireon/GetAsset?vin=${vin}&storeState=${storeState}&account=${account}`);
	},
	getLoJackEvents: (deviceId: any, account: any, getAllEvents = false) => {
		return request.getSpecial(`/Spireon/GetLoJackEvents?deviceId=${deviceId}&account=${account}&getAllEvents=${getAllEvents}`);
	},
	getLoJackEventsAfterDate: (deviceId: any, account: any, startDate: string) => {
		return request.getSpecial(`/Spireon/GetLoJackEventsAfterDate?deviceId=${deviceId}&account=${account}&startDate=${startDate}`);
	},
	pingAssetById: (assetId: any, account: any) => {
		return request.postSpecial(`/Spireon/PingAssetById?assetId=${assetId}&account=${account}`);
	},
	getVehicleEventsByVin: (vin: string) => {
		return request.postSpecial(`/Spireon/GetVehicleEventsByVin?vin=${vin}`);
	},
	saveLoJackEvents: (vehicleEvents: VehicleEvent[]) => {
		return request.postSpecial(`/Spireon/SaveLoJackEvents`, vehicleEvents);
	},
};
